
import { Outlet } from 'react-router-dom';

const Karyawan = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default Karyawan;
